import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import * as rest from '../../../services'
import * as components from '../../../components'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import InviteCustomerForm from './InviteCustomerForm'
import { setCounterNumber } from '../../../state/token'

const InviteCustomerFormPane = ({ token, onInvite }) => {
  const { counterNumber } = useSelector((state) => state.machineConfig)
  const dispatch = useDispatch()
  const inviteCustomer = (values, via_sms) => {
    dispatch(setCounterNumber(values.counter_number))
    const { url } = token
    let u = via_sms
      ? 'invite_customer_to_counter_via_sms'
      : 'invite_customer_to_counter'
    rest.RestService.call_url_action(`${url}${u}/`, 'POST', values)
      .then((res) => {
        dispatch(
          showSuccessToast(
            'Success',
            `${token.first_name} has been invited to Counter ${values.counter_number} `
          )
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Could not invite user to counter ',
            errors.response.data
          )
        )
      })
  }

  return (
    <>
      {counterNumber && (
        <>
          <ReactBootstrap.NavDropdown.Item
            onClick={() =>
              inviteCustomer({
                counter_number: counterNumber,
              })
            }
          >
            <>
              {components.ICONS.CALL} Call to Counter {counterNumber}
            </>
          </ReactBootstrap.NavDropdown.Item>
          <ReactBootstrap.NavDropdown.Item
            onClick={() =>
              inviteCustomer(
                {
                  counter_number: counterNumber,
                },
                true
              )
            }
          >
            <>
              {components.ICONS.CALL} Call via SMS to Counter {counterNumber}
            </>
          </ReactBootstrap.NavDropdown.Item>
        </>
      )}

      <components.Slider
        buttonType="dropdown"
        title={<>{components.ICONS.CALL} Call To Different Counter Number</>}
      >
        <InviteCustomerForm
          onSubmit={(values) => inviteCustomer(values, false)}
          token={token}
        />
      </components.Slider>
      <components.Slider
        buttonType="dropdown"
        title={
          <>{components.ICONS.CALL} Call By Different Counter Number via SMS</>
        }
      >
        <InviteCustomerForm
          onSubmit={(values) => inviteCustomer(values, true)}
          token={token}
        />
      </components.Slider>
    </>
  )
}

export default InviteCustomerFormPane
